import { render, staticRenderFns } from "./SpanLayoutConfig.vue?vue&type=template&id=1dd73409&scoped=true"
import script from "./SpanLayoutConfig.vue?vue&type=script&lang=js"
export * from "./SpanLayoutConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd73409",
  null
  
)

export default component.exports